/* global axios */
import ApiClient from '../ApiClient';

class AssistantCustomTools extends ApiClient {
  constructor() {
    super('assistant/custom_tools', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, search_key: searchKey },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { custom_tool: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { custom_tool: data });
  }

  test({ customTool, testParams } = {}) {
    return axios.post(`${this.url}/test`, {
      custom_tool: customTool,
      test_params: testParams,
    });
  }
}

export default new AssistantCustomTools();
